import React from 'react';
import { FormControl, FormHelperText, InputLabel } from '@mui/material';
import {Close} from '@mui/icons-material';
import { useUploadFile } from './hooks/useUploadFile';
import { FieldProps } from '@rjsf/core';
import './style/style.scss'
import { ChartDonut } from 'components/chart';

export const UploadFile: React.FC<FieldProps> = (props: FieldProps) => {
    const {
        docId,
        docName,
        base64,
        accept,
        progress,
        errorMessage,
        handleUpload,
        handleRemoveFile
    } = useUploadFile(props)
    
    const { title: label } = props.schema
    return(
        <>
            <FormControl className={`control-upload-file ${props.className}`}>
                <InputLabel>{label}</InputLabel>
                <div className="wrapper">
                    {
                        (docId && docName) &&
                        <>
                            {
                                (accept ===  'img' && base64) ? 
                                <div className="suploadfile-preview">
                                    <p>
                                        <Close className="suploadfile-delete" onClick={handleRemoveFile}/>
                                        <img 
                                            src={`data:image/jpeg;base64,${base64}`} 
                                            alt='pict' />
                                        {docName}
                                    </p>
                                </div>
                                : <p>{docName}</p>
                            }
                        </>
                    }
                    {
                        (progress !== 0 && !docId) &&
                        <ChartDonut
                            className="ml-0 mr-10"
                            value={progress}
                            size={32}
                            thickness={6}
                            fontSize={10}
                            />
                    }

                    {
                        (!docId || !docName) &&
                        <label htmlFor="uploadfile">
                            <input 
                                type="file" 
                                id="uploadfile" 
                                className="d-none" 
                                onChange={handleUpload} 
                                accept={accept ==  "img" ? "image/*," : ""} 
                                />
                            Choisir un fichier
                        </label>
                    }
                </div>
            </FormControl>
            {
                errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>
            }
        </>
    )
}
